module.exports = __webpack_public_path__ + "img/delicacies-2.9d63b89b.png";